import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class HolidaysService {

  public url: string;
  public token;
  public headers;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url + '/holiday_request/';
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  availability(json, id): Observable<any> {
    return this.petition(this.url + 'status/' + id + '?page=1', json);
  }

  create(json): Observable<any> {
    return this.petition(this.url + 'new?page=1', json);
  }

  update(json, id): Observable<any> {
    return this.petition(this.url + 'edit/' + id + '?page=1', json);
  }

  approve(json, id): Observable<any> {
    return this.petition(this.url + 'editsignature/' + id + '?page=1', json);
  }

  showOne(id): Observable<any> {
    return this.petition(this.url + 'detail/' + id + '?page=1');
  }

  revisePTO(json, id): Observable<any> {
    return this.petition(this.url + 'recalculate/' + id + '?page=1', json);
  }

  showAll(byId: number = null, year = '', page = '1', perpage = '10', search = '', status='all'): Observable<any> {
    let url, json;
    json = { year, search };
    url = this.url + 'list';

    if (byId !== null) {
      url = url + '/' + byId;
    }
    return this.petition(url + `?page=${page}&perpage=${perpage}&status=${status}`, json);
  }
  showAllFilter(byId: number = null, year = '', page = '1', perpage = '10', search = '', status='all',  filtros: any[] = [],    task:any,
  order:any): Observable<any> {
    let url, json;
    json = { year, search,sort : [task],order };
    url = this.url + 'listopti';
    if (byId !== null) {
      url = url + '/' + byId;
    }
    let newulr = url + `?page=${page}&perpage=${perpage}&status=${status}`;
    filtros.forEach(filtro => {
      if (filtro && filtro.value) {
        newulr += `&${filtro.key}=${encodeURIComponent(filtro.value)}`;
        if (filtro.key_type) {
          newulr += `&${filtro.key_type}=${encodeURIComponent(filtro.type)}`;
        }
      }
    });
    return this.petition(newulr, json);
  }
  delete(id): Observable<any> {
    return this.petition(this.url + 'remove/' + id + '?page=1');
  }

  petition(url, json = null, type = null): Observable<any> {

    this.token = JSON.parse(localStorage.getItem('token'));
    let params = new HttpParams().set('authorization', this.token);

    if (json != null) {
      //json = encodeURIComponent(JSON.stringify(json));
      json = JSON.stringify(json);
      params = params.set('json', json);
    }

    if (type != null) {
      params = params.set('type', type);
    }

    return this._http.post(
      url,
      params,
      {headers: this.headers}
    );
  }

}
